import globalStyles from '../../styles/ButtonGradient.module.css';
import { FiDownload } from 'react-icons/fi';

const DownloadPDFButton = ({ onClick }) => {
  return (
    <button className={globalStyles.button} onClick={onClick}>
      <FiDownload className={globalStyles.icon} />
      Export Roster
    </button>
  );
};

export default DownloadPDFButton;